import * as Yup from 'yup';
import { isValidPhone } from '@rsos/utils/validators';

/* constants */
export const CALL_FLOW = 'alert_share';
export const CALL_FLOW_NEXT = 'alert_share_v2';
export const SHARE_SUCCESS_MESSAGE = 'Event data sent.';
export const SHARE_ERROR_MESSAGE =
  'Event data failed to share. Please try again.';
export const initialValues = {
  email: '',
  emailsCumulative: [],
  phoneNumber: '',
  phoneNumbersCumulative: [],
  consentShare: false,
};

/* Validators */
export const validationSchema = Yup.object().shape({
  emailsCumulative: Yup.array().test(
    'isEmailsValid',
    'Invalid email address.',
    function (value) {
      const { path, createError } = this;
      const result = value.find(v => !v.isValid)
        ? createError({ path, message: 'Invalid email(s) address.' })
        : true;
      return result;
    },
  ),
  phoneNumbersCumulative: Yup.array().test(
    'isPhoneNumberValid',
    'Invalid phone number.',
    function (value) {
      const { path, createError } = this;
      const result = value.find(v => !v.isValid)
        ? createError({ path, message: 'Invalid phone number(s).' })
        : true;
      return result;
    },
  ),
  consentShare: Yup.bool().oneOf([true], 'Consent for sharing is required'),
});

export const phoneNumberValidator = val => {
  const sanitizedValue = val.replace(/[()-\s]/g, '');
  return isValidPhone(sanitizedValue);
};

/* Function to prepend +1 to any phone number to match BE validation */
export const sanitizedPhoneNumber = phoneNumber => {
  let standardPhoneNumber;
  standardPhoneNumber =
    phoneNumber && phoneNumber.substring(0, 1) === '1'
      ? '+' + phoneNumber
      : '+1' + phoneNumber;
  return standardPhoneNumber.replace(/[()-\s]/g, '');
};

/* Function to remove duplicates from an array */
const getUniqueArrayValues = array => {
  return array.filter((value, index) => array.indexOf(value) === index);
};

/**
 * Function to get sanitized and unique values from an array
 * @param {Object} values - represents Formik's values object
 * @param {string} type - represents the type of value, it is consistent with the initial value
 * coming from Formik declaration
 */
export const getSanitizedUniqueValues = (values, type) => {
  if (values && values[type] && values[type].length > 0) {
    switch (type) {
      case 'phoneNumbersCumulative': {
        const sanitizedValues = values[type].map(n =>
          sanitizedPhoneNumber(n.value),
        );
        return getUniqueArrayValues(sanitizedValues);
      }
      case 'emailsCumulative': {
        const sanitizedValues = values[type].map(n => n.value);
        return getUniqueArrayValues(sanitizedValues);
      }
      default:
        return [];
    }
  } else {
    return [];
  }
};
